import SiteLayout from '@/components/feature/SiteLayout';
import Seo from '@/components/feature/Seo';
import HeroSection from './components/HeroSection';
import SpotlightSection from './components/SpotlightSection';
import LiveFeedSection from './components/LiveFeedSection';
import CategoryGrid from './components/CategoryGrid';
import HotRankingSection from './components/HotRankingSection';
import EditorPicksSection from './components/EditorPicksSection';
import TestimonialsSection from './components/TestimonialsSection';
import SubmitBanner from './components/SubmitBanner';

export default function Home() {
  const jsonLd = [
    {
      '@context': 'https://schema.org',
      '@type': 'Organization',
      name: '深夜爆料',
      url: 'https://shenyebaoliao.example.com',
      description:
        '深夜爆料新料首发专区，聚焦第一手独家内容，新瓜速递不间断更新。',
      email: 'baoliao@shenyebaoliao.com',
    },
    {
      '@context': 'https://schema.org',
      '@type': 'WebSite',
      name: '深夜爆料',
      alternateName: '深夜爆料首发专区',
      url: 'https://shenyebaoliao.example.com',
      inLanguage: 'zh-CN',
      potentialAction: {
        '@type': 'SearchAction',
        target: 'https://shenyebaoliao.example.com/category/yule?q={search_term_string}',
        'query-input': 'required name=search_term_string',
      },
    },
    {
      '@context': 'https://schema.org',
      '@type': 'WebPage',
      name: '深夜爆料｜第一手独家 新瓜速递抢先看',
      description:
        '深夜爆料新料首发专区，聚焦第一手独家内容，新瓜速递不间断更新，抢先掌握首发动态。',
      inLanguage: 'zh-CN',
    },
  ];

  return (
    <SiteLayout overlayHeader>
      <Seo
        title="深夜爆料｜第一手独家 新瓜速递抢先看"
        description="深夜爆料新料首发专区，聚焦深夜爆料第一手独家内容，新瓜速递不间断更新。想抢先看最新爆料、掌握深夜爆料首发动态，点进来就能找到热乎的料。"
        keywords="深夜爆料,深夜爆料首发,深夜爆料第一手,深夜爆料独家,深夜爆料新瓜,深夜爆料速递"
        path="/"
        ogImage="https://readdy.ai/api/search-image?query=Abstract%20midnight%20city%20alley%20with%20warm%20amber%20neon%20glow%20and%20drifting%20fog%2C%20deep%20charcoal%20and%20crimson%20tones%2C%20moody%20artistic%20night%20photography%20with%20strong%20negative%20space%2C%20cinematic%20and%20minimal&width=1800&height=1000&seq=shenye-hero-main-01&orientation=landscape"
        jsonLd={jsonLd}
      />
      <HeroSection />
      <SpotlightSection />
      <LiveFeedSection />
      <CategoryGrid />
      <HotRankingSection />
      <EditorPicksSection />
      <TestimonialsSection />
      <SubmitBanner />
    </SiteLayout>
  );
}